import React from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { isEmpty, startCase } from 'lodash'
import Pagination from 'pages/Pagination'
import helper from 'utils/helpers'
import OImage from 'components/reusable/OImage'
import homeImg from '../../../assets/images/home.png'
import { NavLink } from 'react-router-dom'

const AuctionProperty = ({
  pendingStatus,
  auctionData,
  paginationObj,
  page,
  handlePageClick
}) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='p-3'>
        <div className='overflow-x-auto relative 
 border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  #
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_PROPERTY_IMAGE')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_BID_ID')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_PROPERTY_TITLE')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_PROPERTY_CATEGORY_NAME')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_BID_AMOUNT')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_BID_FEES')}
                </th>
                <th scope='col' className='py-3 px-6 cursor-pointer'>
                  {t('O_AUCTION_START_DATE')}
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('O_AUCTION_END_DATE')}
                </th>
                <th scope='col' className='py-3 px-6 '>
                  {t('O_STATUS')}
                </th>

                <th scope='col' className='py-3 px-6 text-center'>
                  {t('O_ACTION')}
                </th>
              </tr>
            </thead>
            <tbody>
              {auctionData &&
                auctionData.length > 0 &&
                auctionData?.map((item, i) => (
                  <tr
                    key={i}
                    className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                  >
                    <th
                      scope='row'
                      className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className='py-3 px-6 border-r text-center'>
                      <figure className='inline-block overflow-hidden rounded-full border-2 mb-0'>
                        <OImage
                          src={
                            item?.property?.photos?.length >= 1
                              ? item?.property?.photos[0]
                              : homeImg
                          }
                          fallbackUrl={homeImg}
                          className='w-10 h-10'
                        />
                      </figure>
                    </td>
                    <td className='py-2 px-2 border-r'>{item?.bidId}</td>
                    <td className='py-2 px-2 border-r'>
                      {startCase(item?.property?.title)}
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {startCase(item?.propertyCategory?.name)}
                    </td>
                    <td className='py-2 px-2 border-r'>{item?.bidPrice} SAR</td>
                    <td className='py-2 px-2 border-r '>
                      {item?.property?.biddingFees} SAR
                    </td>
                    <td className='py-2 px-2 border-r'>
                      {dayjs(item?.property?.auctionStartDateTime).format(
                        'llll'
                      )}
                    </td>

                    <td className='py-2 px-2 border-r '>
                      {dayjs(item?.property?.auctionEndDateTime).format('llll')}
                    </td>

                    {/* <td className='py-2 px-2 border-r '>
                      {item?.status!=='pending' ? (
                        item?.status
                      ) : (
                        <span className='text-[#ff1111]'>
                          {' '}
                          {t('O_AUCTIONS_ENDS') +
                            ' ' +
                            helper.remainingTimeFromNow(
                              item?.property?.auctionEndDateTime
                            )}
                        </span>
                      )}
                    </td> */}
                    {console.log(' item?.auctionStatus', item)}
                    <td className='py-2 px-2 border-r '>
                      {item?.property?.auctionStatus !== 'active' ? (
                        <span className='hover:bg-white text-red-500'>
                          {item?.property?.auctionStatus}
                        </span>
                      ) : (
                        <span className='text-[#ff1111]'>
                          {' '}
                          {t('O_AUCTIONS_ENDS') +
                            ' ' +
                            helper.remainingTimeFromNow(
                              item?.property?.auctionEndDateTime
                            )}
                        </span>
                      )}
                    </td>
                    <td className='py-4 px-6 border-l'>
                      <div className=''>
                        <ul className='flex justify-center'>
                          <>
                            {/* <li
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                              onClick={() => handleUserView(item)}
                            >
                              {t('O_VIEW_PROPERTY_DETAILS')}
                            </li> */}
                            <NavLink
                              to={`/properties/view/${item._id}`}
                              state={{ item, propertyId: item?.property?._id }}
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                            >
                              {t('O_VIEW_PROPERTY_DETAILS')}
                            </NavLink>
                          </>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              {isEmpty(auctionData) ? (
                <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-4 px-6' colSpan={12}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      {paginationObj?.totalItems !== 0 && (
        <Pagination
          handlePageClick={handlePageClick}
          options={paginationObj}
          page={page}
        />
      )}
    </>
  )
}

export default AuctionProperty
